<template>
  <div @contextmenu.prevent style="user-select: none; cursor: default;">
    <div class="mainContainer">
      <v-card color="primary" elevation="0" rounded="0">
        <div style="display: flex; align-items: center; padding: 15px;">
          <v-icon size="large" color="indigo">mdi-source-branch</v-icon>
          <v-icon color="indigo">mdi-account</v-icon>
          <v-icon size="small" color="indigo" style="margin-right: 10px;">mdi-plus-circle</v-icon>
          <h3>GENERAR SEGUIMIENTO DE CONTACTO</h3>
        </div>
      </v-card>
      <div class="contentContainer">
        <div class="columnContainer">
          <v-card color="primary" elevation="0" rounded="0" class="footerContainer">
            <div class="inputContainer">
              <v-select
                ref="CRMWhatsappContactFilter"
                v-model="input.CRMWhatsappContactFilter"
                @update:model-value="selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupView(true)"
                :items="computed_CRMWhatsappContactFilterOptions"
                :loading="loader.selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupView"
                :disabled="loader.selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupView"
                label="Filtrar contacto"
                variant="outlined"
                density="compact"
                item-value="value"
                item-title="title"
                hide-details
              >
                <template v-slot:item="{ props, item }">
                  <v-list-item v-bind="props">
                    <template v-slot:prepend>
                      <v-icon>mdi-{{ item.value == null ? 'account-question' : item.value ? 'close-circle' : 'clock' }}</v-icon>
                    </template>
                  </v-list-item>
                </template>
                <template v-slot:prepend-inner>
                  <v-icon>mdi-{{ input.CRMWhatsappContactFilter == null ? 'account-question' : input.CRMWhatsappContactFilter ? 'close-circle' : 'clock' }}</v-icon>
                </template>
              </v-select>
              <v-autocomplete 
                ref="CRMWhatsappContactSearch"
                v-model="input.CRMWhatsappContactID"
                v-model:search="input.CRMWhatsappContactSearch"
                @input="autocompleteCRMWhatsappContactInterval()"
                @update:model-value="selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupView(true)"
                :items="display.autocompleteCRMWhatsappContacts"
                :prepend-inner-icon="(input.CRMWhatsappContactSearch && /\S/.test(input.CRMWhatsappContactSearch)) || input.CRMWhatsappContactID ? 'mdi-account-off' : 'mdi-account'"
                @click:prepend-inner="$generalFunctions.default.blurInput(this, 'CRMWhatsappContactSearch'); input.CRMWhatsappContactSearch = null; autocompleteCRMWhatsappContactInterval();"
                :loading="loader.autocompleteCRMWhatsappContact || loader.selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupView"
                :disabled="loader.selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupView"
                item-value="CRMWhatsappContactID"
                item-title="CRMWhatsappContactName"
                label="Buscar contacto"
                density="compact"
                variant="outlined"
                autocomplete="off"
                hide-no-data
                hide-details
              >
                <template v-slot:item="{ props, item }">
                  <v-list-item v-bind="props">
                    <p style="font-size: small; color: #9e9e9e;">{{ $displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(item.raw.CRMWhatsappContactPhoneNumber, false) }}</p>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </div>
            <template v-if="display.CRMWhatsappContacts.length > 0">
              <div class="paginatorContainer">
                <!--
                <v-pagination 
                  v-model="navigation.CRMWhatsappContactPage"
                  @update:model-value="selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupView(false)"
                  :length="Math.ceil(display.CRMWhatsappContactCount / navigation.CRMWhatsappContactLimit)"
                  :total-visible="5"
                  :disabled="loader.selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupView || loader.selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupViewPagination"
                  density="compact"
                  size="small"
                >
                </v-pagination>
                -->
                <v-select
                  v-model="navigation.CRMWhatsappContactPage"
                  :items="Array.from({ length: Math.ceil(display.CRMWhatsappContactCount / navigation.CRMWhatsappContactLimit) },(_, i) => i + 1)"
                  @update:model-value="selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupView(false)"
                  :disabled="loader.selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupView || loader.selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupViewPagination"
                  label="Página"
                  density="compact"
                  variant="outlined"
                  hide-details
                  style="width: 200px"
                ></v-select>
                <p style="font-size: x-small;">{{ (navigation.CRMWhatsappContactPage - 1) * navigation.CRMWhatsappContactLimit + 1 }} - {{ ((navigation.CRMWhatsappContactPage - 1) * navigation.CRMWhatsappContactLimit + navigation.CRMWhatsappContactLimit) > display.CRMWhatsappContactCount ? display.CRMWhatsappContactCount : ((navigation.CRMWhatsappContactPage - 1) * navigation.CRMWhatsappContactLimit + navigation.CRMWhatsappContactLimit) }} de {{ display.CRMWhatsappContactCount }} contacto{{ display.CRMWhatsappContactCount > 1 ? 's' : '' }}</p>
              </div>
            </template>
          </v-card>   
          <v-data-table
            :items="display.CRMWhatsappContacts"
            :headers="computed_CRMWhatsappContactHeaders"
            :loading="loader.selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupView"
            :items-per-page="-1"
            loading-text=""
            fixed-header
            class="table"
          >
            <template v-slot:header.CRMWhatsappContactIsFollowupable>
              <div style="display: flex; align-items: center; white-space: nowrap;">
                <v-icon color="indigo" style="margin-right: 5px;">mdi-account-question</v-icon>
                <p><strong>CONSIDERAR</strong></p>
              </div>
            </template>
            <template v-slot:header.CRMWhatsappContactID>
              <div style="display: flex; align-items: center; white-space: nowrap;">
                <v-icon color="indigo" style="margin-right: 5px;">mdi-barcode</v-icon>
                <p><strong>ID</strong></p>
              </div>
            </template>
            <template v-slot:header.CRMWhatsappContactPhoneNumber>
              <div style="display: flex; align-items: center; white-space: nowrap;">
                <v-icon color="indigo" style="margin-right: 5px;">mdi-account</v-icon>
                <p><strong>CONTACTO</strong></p>
              </div>
            </template>
            <template v-slot:header.lastCRMWhatsappConversationDatetime>
              <div style="display: flex; align-items: center; white-space: nowrap;">
                <v-icon color="indigo">mdi-chat</v-icon>
                <v-icon color="indigo" size="x-small" style="margin-right: 5px;">mdi-clock</v-icon>
                <p><strong>ÚLTIMA CONVERSACIÓN</strong></p>
              </div>
            </template>
            <template v-slot:header.lastCRMWhatsappInvoiceDatetime>
              <div style="display: flex; align-items: center; white-space: nowrap;">
                <v-icon color="indigo">mdi-invoice-text</v-icon>
                <v-icon color="indigo" size="x-small" style="margin-right: 5px;">mdi-clock</v-icon>
                <p><strong>ÚLTIMA ORDEN</strong></p>
              </div>
            </template>
            <template v-slot:header.CRMWhatsappConversationHistoryAction>
              <div style="display: flex; align-items: center; white-space: nowrap;">
                <v-icon color="indigo" style="margin-right: 5px;">mdi-history</v-icon>
                <p><strong>HISTORIAL</strong></p>
              </div>
            </template>
            <template v-slot:header.CRMWhatsappContactFollowupAction>
              <div style="display: flex; align-items: center; white-space: nowrap;">
                <v-icon color="indigo" style="margin-right: 5px;">mdi-plus-circle</v-icon>
                <p><strong>GENERAR SEGUIMIENTO</strong></p>
              </div>
            </template>
            <template v-slot:item.CRMWhatsappContactIsFollowupable="{ item }">
              <v-switch
                v-model="item.CRMWhatsappContactIsFollowupable"
                @update:model-value="updateCRMWhatsappContactIsFollowupableFromInsertCRMWhatsappContactFollowupView(item)"
                :disabled="item.loader"
                color="indigo"
                density="compact"
                hide-details
              >
              </v-switch>
            </template>
            <template v-slot:item.CRMWhatsappContactFilter="{ item }">
              <template v-if="item.lastCRMWhatsappConversationDatetime || item.quickFix_remove">
                <v-hover v-slot="{ isHovering, props: hoverProps }">
                  <template v-if="isHovering == true && !systemInformationData.tooltipDisabled">
                    <v-tooltip v-bind="hoverProps" text="Contacto sin conversación en los últimos 30 días" location="top">
                      <template v-slot:activator="{ props: tooltipProps }">
                        <v-icon v-bind="tooltipProps" class="hoverableElement" color="error">mdi-clock</v-icon>
                      </template>
                    </v-tooltip>
                  </template>
                  <template v-else>
                    <v-icon v-bind="hoverProps" class="hoverableElement" color="error">mdi-clock</v-icon>
                  </template>
                </v-hover>
              </template>
              <template v-else>
                <v-hover v-slot="{ isHovering, props: hoverProps }">
                  <template v-if="isHovering == true && !systemInformationData.tooltipDisabled">
                    <v-tooltip v-bind="hoverProps" text="Contacto sin conversaciones" location="top">
                      <template v-slot:activator="{ props: tooltipProps }">
                        <v-icon v-bind="tooltipProps" class="hoverableElement" color="grey">mdi-close-circle</v-icon>
                      </template>
                    </v-tooltip>
                  </template>
                  <template v-else>
                    <v-icon v-bind="hoverProps" class="hoverableElement" color="grey">mdi-close-circle</v-icon>
                  </template>
                </v-hover>
              </template>
            </template>
            <template v-slot:item.CRMWhatsappContactID="{ item }">
              <v-hover v-slot="{ isHovering, props: hoverProps }">
                <template v-if="isHovering == true && !systemInformationData.tooltipDisabled">
                  <v-tooltip v-bind="hoverProps" text="Copiar ID al portapapeles" location="top">
                    <template v-slot:activator="{ props: tooltipProps }">
                      <p v-bind="tooltipProps" @click="$generalFunctions.default.copyToClipboard(this, 'ID del contacto', 'o', item.CRMWhatsappContactID)" class="hoverableElement" style="color: #3F51B5;"><strong>{{ item.CRMWhatsappContactID }}</strong></p>
                    </template>
                  </v-tooltip>
                </template>
                <template v-else>
                  <p v-bind="hoverProps" @click="$generalFunctions.default.copyToClipboard(this, 'ID de la conversación', 'o', item.CRMWhatsappContactID)" class="hoverableElement" style="color: #3F51B5;"><strong>{{ item.CRMWhatsappContactID }}</strong></p>
                </template>
              </v-hover>
            </template>
            <template v-slot:item.CRMWhatsappContactPhoneNumber="{ item }">
              <div style="white-space: nowrap;">
                <p>{{ $displayFunctions.default.parseCRMWhatsappContactNameToDisplay(item) }}</p>
                <p style="font-size: small; color: #9e9e9e;">{{ $displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(item.CRMWhatsappContactPhoneNumber, false) }}</p>
              </div>
            </template>
            <template v-slot:item.lastCRMWhatsappConversationDatetime="{ item }">
              <div style="white-space: nowrap;">
                <template v-if="item.lastCRMWhatsappConversationDatetime">
                  <p>{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(item.lastCRMWhatsappConversationDatetime) }}</p>
                  <p style="font-size: small; color: #9e9e9e;">{{ $displayFunctions.default.getDatetimeOffsetToDayHHMMSS(item.lastCRMWhatsappConversationDatetime) }}</p>
                </template>
                <template v-else-if="item.quickFix_remove">
                  <p>Contacto migrado del sistema anterior</p>
                </template>
                <template v-else>
                  <p>No registrado</p>
                </template>
              </div>
            </template>
            <template v-slot:item.lastCRMWhatsappInvoiceDatetime="{ item }">
              <div style="white-space: nowrap;">
                <template v-if="item.lastCRMWhatsappInvoiceDatetime">
                  <p>{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(item.lastCRMWhatsappInvoiceDatetime) }}</p>
                  <p style="font-size: small; color: #9e9e9e;">{{ $displayFunctions.default.getDatetimeOffsetToDayHHMMSS(item.lastCRMWhatsappInvoiceDatetime) }}</p>
                </template>
                <template v-else-if="item.quickFix_remove">
                  <p>Contacto migrado del sistema anterior</p>
                </template>
                <template v-else>
                  <p>No registrado</p>
                </template>
              </div>
            </template>
            <template v-slot:item.CRMWhatsappConversationHistoryAction="{ item }">
              <v-btn @click="$root.dialogComponent.openCRMWhatsappConversationHistoryDialog(item.CRMWhatsappContactID)" color="primary" class="hoverableText">
                <v-icon size="small" style="margin-right: 10px;">mdi-history</v-icon>
                <p style="font-size: small;">HISTORIAL</p>
              </v-btn>
            </template>
            <template v-slot:item.CRMWhatsappContactFollowupAction="{ item }">
              <v-btn @click="$root.dialogComponent.openSendCRMWhatsappMessageToCRMWhatsappContactDialog(item.CRMWhatsappContactID, true)" color="indigo" class="hoverableText">
                <v-icon size="small" style="margin-right: 10px;">mdi-plus-circle</v-icon>
                <p style="font-size: small;">GENERAR SEGUIMIENTO</p>
              </v-btn>
            </template>
            <template v-slot:no-data>
              <template v-if="navigation.noCRMWhatsappContactData">
                <div style="text-align: center; padding: 15px;" class="hoverableText">
                  <v-icon size="large" color="indigo">mdi-information</v-icon>
                  <p style="margin-top: 10px; color: 9e9e9e;">No se ha encontrado ningún contacto con los criterios de búsqueda o filtros aplicados</p>
                  <p style="color: 9e9e9e;">Haz click <span style="text-decoration: underline; color: #3F51B5;" @click="input.CRMWhatsappContactFilter = false; input.CRMWhatsappContactSearch = null; input.CRMWhatsappContactID = null; selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupView(true)">aquí</span> para limpiar los criterios de búsqueda y filtrado</p>
                </div>
              </template>
            </template>
            <template v-slot:bottom></template>
          </v-data-table>
          
        </div>
        <div class="columnContainer">
          <v-card color="primary" elevation="0" rounded="0" class="footerContainer footerContainerEvenColumns">
            <template v-if="!loader.selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupView">
              <v-chip color="indigo" variant="flat" elevation="2" label style="text-align: center; display: flex; justify-content: center; align-items: center;">
                <p><strong>{{ display.todayCRMWhatsappContactFollowupCount }}</strong> seguimientos de hoy</p>
              </v-chip>
            </template>
            <template v-if="display.CRMWhatsappContactFollowups.length > 0">
              <div class="paginatorContainer">
                <v-pagination 
                  v-model="navigation.CRMWhatsappContactFollowupPage"
                  @update:model-value="selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupView(false)"
                  :length="Math.ceil(display.CRMWhatsappContactFollowupCount / navigation.CRMWhatsappContactFollowupLimit)"
                  :total-visible="5"
                  :disabled="loader.selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupView || loader.selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupViewPagination"
                  density="compact"
                  size="small"
                >
                </v-pagination>
                <p style="font-size: x-small;">{{ (navigation.CRMWhatsappContactFollowupPage - 1) * navigation.CRMWhatsappContactFollowupLimit + 1 }} - {{ ((navigation.CRMWhatsappContactFollowupPage - 1) * navigation.CRMWhatsappContactFollowupLimit + navigation.CRMWhatsappContactFollowupLimit) > display.CRMWhatsappContactFollowupCount ? display.CRMWhatsappContactFollowupCount : ((navigation.CRMWhatsappContactFollowupPage - 1) * navigation.CRMWhatsappContactFollowupLimit + navigation.CRMWhatsappContactFollowupLimit) }} de {{ display.CRMWhatsappContactFollowupCount }} seguimiento{{ display.CRMWhatsappContactFollowupCount > 1 ? 's' : '' }}</p>
              </div>
            </template>
          </v-card>
          <v-card color="primary" elevation="0" rounded="0" class="table">
            <template v-if="loader.selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupView">
              <div style="height: 100%; width: 100%; display: flex; justify-content: center; align-items: center;">
                <v-progress-circular indeterminate></v-progress-circular>
              </div>
            </template>
            <template v-else>
              <template v-if="display.CRMWhatsappContactFollowups.length > 0">
                <div style="padding: 0px 15px; display: flex; flex-direction: column; gap: 15px;">
                  <template v-for="CRMWhatsappContactFollowup in display.CRMWhatsappContactFollowups" v-bind:key="CRMWhatsappContactFollowup.CRMWhatsappContactFollowupID">
                    <v-card class="hoverableText" style="padding: 10px;">
                      <div style="display: flex; flex-direction: column; gap: 5px;">
                        <div style="display: flex; gap: 5px; align-items: center;">
                          <v-icon color="indigo">mdi-barcode</v-icon>
                          <p><strong>ID: </strong>{{ CRMWhatsappContactFollowup.CRMWhatsappContactFollowupID }}</p>
                        </div>
                        <div style="display: flex; gap: 5px; align-items: center;">
                          <v-icon color="indigo">mdi-account</v-icon>
                          <p><strong>Contacto: </strong>{{ $displayFunctions.default.parseCRMWhatsappContactNameToDisplay(CRMWhatsappContactFollowup) }}</p>
                        </div>
                        <div style="display: flex; gap: 5px; align-items: center;">
                          <v-icon color="indigo">mdi-phone</v-icon>
                          <p><strong>Teléfono: </strong>{{ $displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(CRMWhatsappContactFollowup.CRMWhatsappContactPhoneNumber) }}</p>
                        </div>
                        <div style="display: flex; gap: 5px; align-items: center;">
                          <v-icon color="indigo">mdi-calendar-start</v-icon>
                          <p><strong>Creación: </strong>{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(CRMWhatsappContactFollowup.CRMWhatsappContactFollowupCreationDatetime) }}</p>
                        </div>
                        <div style="display: flex; gap: 5px; align-items: center;">
                          <v-icon color="indigo">mdi-calendar-end</v-icon>
                          <p><strong>Actualización: </strong>{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(CRMWhatsappContactFollowup.CRMWhatsappContactFollowupUpdateDatetime) }}</p>
                        </div>
                        <template v-if="CRMWhatsappContactFollowup.CRMWhatsappContactFollowupNote && /\S/.test(CRMWhatsappContactFollowup.CRMWhatsappContactFollowupNote)">
                          <div style="display: flex; gap: 5px; align-items: center;">
                            <v-icon color="indigo">mdi-note</v-icon>
                            <p><strong>Nota: </strong></p>
                            <p style="margin-left: 10px; max-height: 150px; overflow-y: auto; scrollbar-width: thin; -ms-overflow-style: none;">{{ CRMWhatsappContactFollowup.CRMWhatsappContactFollowupNote }}</p>
                          </div>
                        </template>
                      </div>
                    </v-card>
                  </template>
                </div>
              </template>
              <template v-else>
                <template v-if="navigation.noCRMWhatsappContactFollowupData">
                  <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center; height: 100%; padding: 15px;">
                    <v-icon size="large" color="indigo">mdi-information</v-icon>
                    <p style="margin-top: 10px; color: #9e9e9e;">Aún no se ha registrado ningún seguimiento</p>
                  </div>
                </template>
              </template>
            </template>
          </v-card>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .mainContainer {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    height: 100vh;
    max-height: 100vh;
  }
  .contentContainer {
    flex: 1;
    display: grid;
    grid-template-columns: 1.4fr 0.6fr;
    overflow: hidden;
    min-height: 0;
  }
  .columnContainer {
    overflow-y: auto;
    scrollbar-width: thin;
    -ms-overflow-style: none;
    height: 100%;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }
  .table {
    flex: 1;
    overflow: auto;
    scrollbar-width: thin;
    -ms-overflow-style: none;
  }
  .footerContainer {
    display: grid;
    align-items: center;
    grid-template-columns: 1.5fr 0.5fr;
    gap: 10px;
    padding: 0px 0px 15px 15px;
  }
  .footerContainerEvenColumns {
    grid-template-columns: repeat(2, 1fr);
  }
  .inputContainer {
    display: grid;
    align-items: center;
    gap: 10px;
    grid-template-columns: repeat(2, 1fr);
  }
  .paginatorContainer {
    margin-left: auto;
    margin-right: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    padding: 5px;
  }

  @media (max-width: 1200px) {
    .mainContainer {
      height: auto;
      max-height: none;
    }
    .contentContainer {
      display: grid;
      grid-template-columns: 1fr;
      grid-auto-rows: minmax(0, 1fr);
      overflow: visible;
    }
    .columnContainer {
      height: 50vh; 
      min-height: 0;
      overflow-y: auto;
      display: flex;
      flex-direction: column;
    }
    .table {
      flex: 1;
      overflow: auto;
    }
    .inputContainer {
      grid-template-columns: 1fr;
    }
    .footerContainer {
      grid-template-columns: 1fr;
    }
    .paginatorContainer {
      margin-left: 0;
    }
  }
</style>

<script>
  import { systemInformation } from '@/utilities/systemInformation';
  import websocket from '@/utilities/websocket';

  export default {
    inject: ['$generalFunctions', '$displayFunctions'],
    data: () => 
    ({
      input: 
      {
        CRMWhatsappContactFilter: false,
        CRMWhatsappContactSearch: null,
        CRMWhatsappContactID: null
      },
      display: 
      {
        autocompleteCRMWhatsappContacts: [],
        CRMWhatsappContactCount: 0,
        CRMWhatsappContacts: [],
        CRMWhatsappContactFollowupCount: 0,
        CRMWhatsappContactFollowups: [],
        todayCRMWhatsappContactFollowupCount: 0
      },
      navigation: 
      {
        CRMWhatsappContactPage: 1,
        CRMWhatsappContactLimit: 250,
        CRMWhatsappContactFollowupPage: 1,
        CRMWhatsappContactFollowupLimit: 250,
        noCRMWhatsappContactData: false,
        noCRMWhatsappContactFollowupData: false
      },
      loader: 
      {
        autocompleteCRMWhatsappContact: false,
        selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupView: false,
        selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupViewPagination: false
      },
      interval:
      {
        autocompleteCRMWhatsappContact: null
      },
      websocketCallback:
      {
        generateCRMWhatsappContactFollowup: null
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMAgent: null,
        CRMLocalities: null,
        CRMAgents: null,
        volumeLevel: 0,
        tooltipDisabled: false,
        updateSubscription: null
      }
    }),

    computed:
    {
      computed_CRMWhatsappContactFilterOptions(){
        return [
          {title: 'Sin conversación en el último mes', value: false},
          {title: 'Nunca ha tenido una conversación', value: true},
          ...(this.systemInformationData.CRMAgent?.CRMAgentPermissions?.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/insertCRMWhatsappContactFollowup/seeCRMWhatsappContactIsFollowupable')?.CRMAgentPermissionValue == '1' ? [{title: 'No considerados para seguimientos', value: null}] : []),
        ]
      },
      computed_CRMWhatsappContactHeaders(){
        return [
          ...(this.systemInformationData.CRMAgent?.CRMAgentPermissions?.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/insertCRMWhatsappContactFollowup/seeCRMWhatsappContactIsFollowupable')?.CRMAgentPermissionValue == '1' ? [{title: 'CONSIDERAR', value: 'CRMWhatsappContactIsFollowupable'}] : []),
          {title: null, value: 'CRMWhatsappContactFilter'},
          {title: 'ID', value: 'CRMWhatsappContactID'},
          {title: 'CONTACTO', value: 'CRMWhatsappContactPhoneNumber'},
          {title: 'ÚLTIMA CONVERSACIÓN', value: 'lastCRMWhatsappConversationDatetime'},
          {title: 'ÚLTIMA ORDEN', value: 'lastCRMWhatsappInvoiceDatetime'},
          {title: 'HISTORIAL', value: 'CRMWhatsappConversationHistoryAction'},
          {title: 'GENERAR SEGUIMIENTO', value: 'CRMWhatsappContactFollowupAction'}
        ]
      }
    },

    methods:
    {

      async updateCRMWhatsappContactIsFollowupableFromInsertCRMWhatsappContactFollowupView(item){
        item.loader = true;
        const updateCRMWhatsappContactIsFollowupableFromInsertCRMWhatsappContactFollowupViewRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID
          },
          'CRMWhatsappContactID': item.CRMWhatsappContactID,
          'CRMWhatsappContactIsFollowupable': item.CRMWhatsappContactIsFollowupable
        };
        const updateCRMWhatsappContactIsFollowupableFromInsertCRMWhatsappContactFollowupViewResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContact/CRMWhatsappContactFollowup/functions/updateCRMWhatsappContactIsFollowupableFromInsertCRMWhatsappContactFollowupView', updateCRMWhatsappContactIsFollowupableFromInsertCRMWhatsappContactFollowupViewRequestQuery);
        if (updateCRMWhatsappContactIsFollowupableFromInsertCRMWhatsappContactFollowupViewResult.success){
          this.display.CRMWhatsappContactCount = this.display.CRMWhatsappContactCount - 1;
          this.display.CRMWhatsappContacts = this.display.CRMWhatsappContacts.filter(CRMWhatsappContact => CRMWhatsappContact.CRMWhatsappContactID != item.CRMWhatsappContactID);
          this.navigation.noCRMWhatsappContactData = this.display.CRMWhatsappContacts.length == 0;
          this.$root.notificationDialog.showSystemNotificationDialog('updateCRMWhatsappContactIsFollowupableFromInsertCRMWhatsappContactFollowupView_success', 'success', 'Se ha actualizado el contacto exitosamente', null, false);
        } else {
          item.CRMWhatsappContactIsFollowupable = !item.CRMWhatsappContactIsFollowupable;
          this.$root.notificationDialog.showSystemNotificationDialog('updateCRMWhatsappContactIsFollowupableFromInsertCRMWhatsappContactFollowupView_error', 'error', 'Ha ocurrido un error inesperado al actualizar el contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
        item.loader = false;
      },



      async selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupView(newSearch){
        if (newSearch){
          this.display.CRMWhatsappContactCount = 0;
          this.display.CRMWhatsappContacts.length = 0;
          this.display.CRMWhatsappContactFollowupCount = 0;
          this.display.CRMWhatsappContactFollowups.length = 0;
          this.display.todayCRMWhatsappContactFollowupCount = 0;
          this.loader.selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupView = true;
          this.navigation.CRMWhatsappContactPage = 1;
          this.navigation.CRMWhatsappContactFollowupPage = 1;
          this.navigation.noCRMWhatsappContactData = false;
          this.navigation.noCRMWhatsappContactFollowupData = false;
        }
        this.loader.selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupViewPagination = true;
        const selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupViewRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID
          },
          'CRMWhatsappContactID': this.input.CRMWhatsappContactID,
          'CRMWhatsappContactPage': this.navigation.CRMWhatsappContactPage,
          'CRMWhatsappContactLimit': this.navigation.CRMWhatsappContactLimit,
          'CRMWhatsappContactFilter': this.input.CRMWhatsappContactFilter == null ? null : this.input.CRMWhatsappContactFilter,
          'CRMWhatsappContactIsFollowupable': this.input.CRMWhatsappContactFilter != null,
          'CRMWhatsappContactFollowupPage': this.navigation.CRMWhatsappContactFollowupPage,
          'CRMWhatsappContactFollowupLimit': this.navigation.CRMWhatsappContactFollowupLimit
        };
        const selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupViewResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContact/CRMWhatsappContactFollowup/functions/selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupView', selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupViewRequestQuery);
        if (selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupViewResult.success){
          this.display.CRMWhatsappContactCount = selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupViewResult.result.CRMWhatsappContactCount;
          this.display.CRMWhatsappContacts = selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupViewResult.result.CRMWhatsappContacts;
          this.display.CRMWhatsappContactFollowupCount = selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupViewResult.result.CRMWhatsappContactFollowupCount;
          this.display.CRMWhatsappContactFollowups = selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupViewResult.result.CRMWhatsappContactFollowups;
          this.display.todayCRMWhatsappContactFollowupCount = selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupViewResult.result.todayCRMWhatsappContactFollowupCount;
          this.navigation.noCRMWhatsappContactData = this.display.CRMWhatsappContactCount == 0;
          this.navigation.noCRMWhatsappContactFollowupData = this.display.CRMWhatsappContactFollowupCount == 0;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupView_error', 'error', 'Ha ocurrido un error inesperado al seleccionar el contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
        this.loader.selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupView = false;
        this.loader.selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupViewPagination = false;
      },

      async autocompleteCRMWhatsappContact(){
        if (this.interval.autocompleteCRMWhatsappContact) clearTimeout(this.interval.autocompleteCRMWhatsappContact);
        this.loader.autocompleteCRMWhatsappContact = true;
        const autocompleteCRMWhatsappContactRequestQuery = 
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          },
          'CRMWhatsappContactSearch': this.input.CRMWhatsappContactSearch
        };
        const autocompleteCRMWhatsappContactResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContact/functions/autocompleteCRMWhatsappContact', autocompleteCRMWhatsappContactRequestQuery);
        if (autocompleteCRMWhatsappContactResult.success){
          this.display.autocompleteCRMWhatsappContacts = autocompleteCRMWhatsappContactResult.result;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog(autocompleteCRMWhatsappContactResult.result, 'error', 'Ha ocurrido un error inesperado al consultar los contactos, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
        this.loader.autocompleteCRMWhatsappContact = false;
      },

      autocompleteCRMWhatsappContactInterval(){
        if (this.input.CRMWhatsappContactSearch != null && /\S/.test(this.input.CRMWhatsappContactSearch) && this.input.CRMWhatsappContactSearch.length >= 3){
          if (this.interval.autocompleteCRMWhatsappContact) clearTimeout(this.interval.autocompleteCRMWhatsappContact);
          this.interval.autocompleteCRMWhatsappContact = setTimeout(() => {
            clearTimeout(this.interval.autocompleteCRMWhatsappContact);
            this.autocompleteCRMWhatsappContact();
          }, 1000);
        } else {
          if (this.interval.autocompleteCRMWhatsappContact) clearTimeout(this.interval.autocompleteCRMWhatsappContact);
          this.display.autocompleteCRMWhatsappContacts.length = 0;
        }
      },

      connectWebsocket(){
        websocket.connectWebsocket();
        this.websocketCallback.generateCRMWhatsappContactFollowup = async (websocketMessageData) => {
          if (this.display.CRMWhatsappContacts.find(CRMWhatsappContact => CRMWhatsappContact.CRMWhatsappContactID == websocketMessageData.websocketMessageContent.CRMWhatsappContactID)){
            this.display.CRMWhatsappContacts = this.display.CRMWhatsappContacts.filter(CRMWhatsappContact => CRMWhatsappContact.CRMWhatsappContactID != websocketMessageData.websocketMessageContent.CRMWhatsappContactID);
            this.navigation.noCRMWhatsappContactData = this.display.CRMWhatsappContacts.length == 0;
          }
          if (this.systemInformationData.CRMAgent.CRMAgentID == websocketMessageData.websocketMessageContent.CRMAgentID){
            this.selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupView(false);
          }
        };
        if (this.websocketCallback.generateCRMWhatsappContactFollowup) websocket.addWebsocketMessageListener('/CRMWhatsappContact/CRMWhatsappContactFollowup/functions/generateCRMWhatsappContactFollowup', this.websocketCallback.generateCRMWhatsappContactFollowup);
      },

      disconnectWebsocket(){
        if (this.websocketCallback.generateCRMWhatsappContactFollowup) websocket.removeWebsocketMessageListener('/CRMWhatsappContact/CRMWhatsappContactFollowup/functions/generateCRMWhatsappContactFollowup', this.websocketCallback.generateCRMWhatsappContactFollowup);
        this.websocketCallback.generateCRMWhatsappContactFollowup = null;
      },

      async getSystemInformationData(){
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgent = systemInformation.getCRMAgent;
            this.systemInformationData.CRMLocalities = systemInformation.getCRMLocalities;
            this.systemInformationData.CRMAgents = systemInformation.getCRMAgents;
            this.systemInformationData.volumeLevel = systemInformation.getVolumeLevel;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
              this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
              this.systemInformationData.volumeLevel = updatedSystemInformationData.volumeLevel;
            });
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformationData_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformationData_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
      }
    },

    async mounted(){
      await this.getSystemInformationData();
      await this.selectCRMWhatsappContactFromInsertCRMWhatsappContactFollowupView(true);
      this.connectWebsocket();
      this.$generalFunctions.default.focusInput(this, 'CRMWhatsappContactSearch');
    },

    beforeUnmount(){
      if (this.systemInformationData.updateSubscription) systemInformation.unsubscribeFromUpdate(this.systemInformationData.updateSubscription);
      this.systemInformationData.updateSubscription = null;
      if (this.interval.autocompleteCRMWhatsappContact) clearTimeout(this.interval.autocompleteCRMWhatsappContact);
      this.interval.autocompleteCRMWhatsappContact = null;
      this.disconnectWebsocket();
    }
  }
</script>